import { httpClient } from "../../../shared/api/httpClient"
import type {
    GrupoCrearRequest,
    GrupoCrearResult,
    GruposBuscarRequest,
    GruposBuscarResult,
    GrupoDeleteRequest,
    GrupoDeleteResult,
    GrupoMostrarRequest,
    GrupoMostrarResult,
    GrupoEditarRequest,
    GrupoEditarResult,
    GruposPermisosListarRequest,
    GruposPermisosListarResult,
    GruposPermisosAgregarRequest,
    GruposPermisosAgregarResult,
    GruposUsuariosPorGrupoRequest,
    GruposUsuariosPorGrupoResult,
    GruposAniadirUsuariosPorGrupoRequest,
    GruposAniadirUsuariosPorGrupoResult,
    GrupoModuloSubirNivelRequest,
    GrupoModuloSubirNivelResult,
    GrupoListarUsuariosPorCompaniaYSucursalesRequest,
    GrupoListarUsuariosPorCompaniaYSucursalesResult,
} from "../types/grupos.types"

export const grupoCrear = async (dataPOST: GrupoCrearRequest): Promise<GrupoCrearResult | undefined> => {
    try {
        const res = await httpClient.post("api/grupo/AgregarGrupo", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: 1,
                message: res.data.message || "",
            }
        }

    } catch (error) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: 0,
                message: error.response.data.message || "",
            };
        }

        return {
            status: -1,
            message: "Error al registrar el usuario",
        }
    }
}

export const gruposBuscar = async (dataPOST: GruposBuscarRequest): Promise<GruposBuscarResult | undefined> => {
    try {
        const res = await httpClient.post("api/grupo/BuscarGrupo", dataPOST)
        // res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                grupos: res.data.resultado,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                grupos: [],
                message: error.response.data.message,
            };
        }
        return {
            status: -1,
            grupos: [],
            message: "Error en el servidor",
        }
    }
}

export const grupoDelete = async (dataPOST: GrupoDeleteRequest): Promise<GrupoDeleteResult | undefined> => {
    try {

        const res = await httpClient.post("api/grupo/EliminarGrupo", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }
    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const grupoMostrar = async (dataPOST: GrupoMostrarRequest): Promise<GrupoMostrarResult | undefined> => {
    try {

        const res = await httpClient.post("api/grupo/MostrarGrupo", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                grupo: res.data.grupo,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                grupo: {},
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            grupo: {},
            message: "Error en el servidor",
        }
    }
}

export const grupoEditar = async (dataPOST: GrupoEditarRequest): Promise<GrupoEditarResult | undefined> => {
    try {
        const res = await httpClient.post("api/grupo/ActualizarGrupo", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const gruposPermisosListar = async (dataPOST: GruposPermisosListarRequest): Promise<GruposPermisosListarResult | undefined> => {
    try {

        const res = await httpClient.post("api/modulo/ListarModuloGrupo", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                modulos: res.data.resultado
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                modulos: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            modulos: []
        }
    }
}

export const gruposPermisosAgregar = async (dataPOST: GruposPermisosAgregarRequest): Promise<GruposPermisosAgregarResult | undefined> => {
    try {

        const res = await httpClient.post("api/modulo/AddModuleGroup", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const gruposUsuariosPorGrupo = async (dataPOST: GruposUsuariosPorGrupoRequest): Promise<GruposUsuariosPorGrupoResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/MostrarGroupUser", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                usuarios: res.data.lista_grupo
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                usuarios: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            usuarios: []
        }
    }
}

export const gruposAniadirUsuariosPorGrupo = async (dataPOST: GruposAniadirUsuariosPorGrupoRequest): Promise<GruposAniadirUsuariosPorGrupoResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/AddGroupUser", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const grupoModuloSubirNivel = async (dataPOST: GrupoModuloSubirNivelRequest): Promise<GrupoModuloSubirNivelResult | undefined> => {
    try {
        const res = await httpClient.post("api/modulo/SubirModuloGrupo", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                modulos: res.data.resultado,
                message: res.data.message,
            }
        }

    } catch (error) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                modulos: [],
                message: "No se encontro módulos",
            };
        }
        return {
            status: -1,
            modulos: [],
            message: "Error en el servidor",
        }
    }
}

export const grupoListarUsuariosPorCompaniaYSucursales= async (dataPOST: GrupoListarUsuariosPorCompaniaYSucursalesRequest): Promise<GrupoListarUsuariosPorCompaniaYSucursalesResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/ListarUsuario", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuarios: res.data.resultado,
                message: res.data.message,
            }
        }

    } catch (error) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuarios: [],
                message: "No se encontro usuarios",
            };
        }
        return {
            status: -1,
            usuarios: [],
            message: "Error en el servidor",
        }
    }
}
